import axios from "axios";
import { AuthRedirectType } from "@teaming/common-enums";
import { extendUserProfile } from "@teaming/io-helpers";

export default function getAuthRedirectBehaviors( { debug, config, } ) {
	async function getUserProfile( { accessToken, } ) {
		debug( "getting the user profile" );
		// intentionally trying to get only the profile first
		// so that we can bail (throw/reject) on 401 ASAP
		const userProfileResponse = await axios( {
			method: "get",
			url: `${ config.baseUri }/user/me`,
			headers: {
				Authorization: `Bearer ${ accessToken }`,
			},
		} );
		const userSettingsResponse = await axios( {
			method: "get",
			url: `${ config.baseUri }/user/me/settings`,
			headers: {
				Authorization: `Bearer ${ accessToken }`,
			},
		} );
		const userProfile = userProfileResponse.data;
		const settings = userSettingsResponse.data;
		return extendUserProfile( { userProfile, settings, } );
	}

	async function signUpUser( { accessToken, timezone, } ) {
		debug( "signing up and getting the user profile" );
		const response = await axios( {
			url: `${ config.baseUri }/user`,
			method: "post",
			headers: {
				Authorization: `Bearer ${ accessToken }`,
				"Content-Type": "application/json",
			},
			data: { timezone, },
		} );
		return response.data;
	}

	return {
		// handling normal login oauth redirects
		[ AuthRedirectType.LOGIN ]: async ( { accessToken, } ) => {
			debug( "handling a login redirect" );
			try {
				const userProfile = await getUserProfile( {
					config,
					accessToken,
				} );
				return {
					userProfile,
					sourceAction: AuthRedirectType.LOGIN,
				};
			} catch ( err ) {
				err.sourceAction = AuthRedirectType.LOGIN;
				throw err;
			}
		},
		// handling signup + login oauth redirects
		[ AuthRedirectType.SIGNUP ]: async ( { accessToken, } ) => {
			debug( "handling a signup redirect" );
			try {
				const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone; // eslint-disable-line new-cap
				const userProfile = await signUpUser( {
					config,
					accessToken,
					timezone,
				} );
				return {
					userProfile,
					sourceAction: AuthRedirectType.SIGNUP,
				};
			} catch ( err ) {
				err.sourceAction = AuthRedirectType.SIGNUP;
				throw err;
			}
		},
		[ AuthRedirectType.CALENDAR ]: async () => {
			debug( "handling a calendar auth redirect" );
			// NOTE: this is here as a placeholder for future work once we
			// know what level of calendar integration behavior we'll need
			// to support after retiring the schedule page in the old repo
		},
		// handling background token renew
		[ AuthRedirectType.SILENT ]: async ( { accessToken, } ) => {
			debug( "handling a token renew redirect" );
			try {
				const userProfile = await getUserProfile( {
					config,
					accessToken,
				} );
				return {
					userProfile,
					sourceAction: AuthRedirectType.SILENT,
				};
			} catch ( err ) {
				err.sourceAction = AuthRedirectType.SILENT;
				throw err;
			}
		},
	};
}
